import React, { useState, useEffect, useCallback } from "react";
import "./css/projekte.css";
import ActiveProjectsCounter from "./couter";
import Projectgrid from "./projectgrid";
import { API_BASE_URL, authHeaders } from "../api";

function Projects() {

  const [projects_counter, setProjectsCounter] = useState(0);
  const [projects, setProjects] = useState([]);
  const projektdata = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/projects`, {
        method: "GET",
        headers: authHeaders({ "Content-Type": "application/json" })
      });

      const data = await response.json();
      console.log(data);

      setProjectsCounter(data.counter);
      setProjects(data.projects);


    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  }, []);

  useEffect(() => {
    projektdata();
  }, [projektdata]);

  return (
    <div className="projects-feat" id="projects">
      <div className="divider">
        <span>Projekte</span>
      </div>

      <ActiveProjectsCounter count={projects_counter} />
      <Projectgrid projects={projects} />
    </div>
  );
}

export default Projects;
